
import React, { useEffect, useState } from 'react';
import { Container, Box, Fab, useTheme } from '@mui/material';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import Footer from '../components/Footer';
import PublicHeader from '../components/PublicHeader';
import RotatingBelt from '../components/RotatingBelt';
import api from '../services/api';

function buildWhatsappLink(contact) {
  if (!contact) return null;
  // try social first
  const socials = Array.isArray(contact.social) ? contact.social : (typeof contact.social === 'string' ? contact.social.split(',') : []);
  for (const s of socials) {
    const url = typeof s === 'string' ? s : (s.url || '');
    if (!url) continue;
    if ((url || '').toLowerCase().includes('whatsapp')) return url.startsWith('http') ? url : `https://wa.me/${url.replace(/[^0-9]/g, '')}`;
  }
  if (contact.phone) return `https://wa.me/${String(contact.phone).replace(/[^0-9]/g, '')}`;
  if (contact.whatsapp) return `https://wa.me/${String(contact.whatsapp).replace(/[^0-9]/g, '')}`;
  return null;
}

const PublicLayout = ({ children }) => {
  const theme = useTheme();
  const [contact, setContact] = useState(null);
  const [waLink, setWaLink] = useState(null);

  useEffect(() => {
    let mounted = true;
    api.get('/api/contact').then(({ data }) => {
      if (!mounted) return;
      setContact(data || {});
      setWaLink(buildWhatsappLink(data || {}));
    }).catch(() => { }).finally(() => { mounted = false; });
    return () => { mounted = false; };
  }, []);

  return (
    <Box sx={{ width: '100%', minHeight: '100vh', bgcolor: 'background.default', display: 'flex', flexDirection: 'column' }}>
      <PublicHeader />
      <RotatingBelt />
      <Box component="main" sx={{ flex: 1, width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'flex-start', pt: { xs: '48px', md: '48px' }, overflow: 'hidden' }}>
        {children}
      </Box>
      <Footer />

      {/* Floating WhatsApp button pinned to the right side (visible across pages) */}
      {waLink && (
        <Box sx={{ position: 'fixed', right: { xs: 12, sm: 20 }, bottom: { xs: 18, sm: 24 }, zIndex: 1400 }}>
          <Fab
            aria-label="whatsapp"
            onClick={() => window.open(waLink, '_blank')}
            sx={{
              bgcolor: '#25D366',
              color: '#fff',
              width: { xs: 56, sm: 64 },
              height: { xs: 56, sm: 64 },
              boxShadow: 6,
              '&:hover': { bgcolor: '#1ebe5a' }
            }}
          >
            <WhatsAppIcon fontSize="large" />
          </Fab>
        </Box>
      )}
    </Box>
  );
};

export default PublicLayout;
